/*
Item: From for displaying 'Datenbestände'
Name: DataStock
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Growl } from 'primereact/growl';
import { ProgressSpinner } from 'primereact/progressspinner';
import { MultiLanguage } from '../utils/MultiLanguage';
import MessageService from '../service/MessageService';
import JsonHelper, { LandNames } from '../utils/statisticsUtils';
import { returnUserRights } from '../utils/roleUtils';

const YesDialogState = Object.freeze({
  invisible: 'invisible',
  delete: 'loeschen',
  lock: 'sperren',
  unlock: 'freigeben',
  loeschen: 'löschen',
  sperren: 'sperren',
  freigeben: 'freigeben',
  StLA_freigeben: 'für das StLA freigeben',
  StBA_freigeben: 'für das StBA freigeben',
  allgemein_freigeben: 'allgemein freigeben',
  stla: 'StLA_freigeben',
  stba: 'StBA_freigeben',
  all: 'allgemein_freigeben',
  unlockLand: 'Ministerium_freigeben',
  Ministerium_freigeben: 'freigeben',
});

const lineTemplate = {
  time: undefined,
  timeClassifyingVariableName: undefined,
  DE: undefined,
  BW: undefined,
  BY: undefined,
  BE: undefined,
  BB: undefined,
  HB: undefined,
  HH: undefined,
  HE: undefined,
  MV: undefined,
  NI: undefined,
  NW: undefined,
  RP: undefined,
  SL: undefined,
  SN: undefined,
  ST: undefined,
  SH: undefined,
  TH: undefined,
  idDE: undefined,
  idBW: undefined,
  idBY: undefined,
  idBE: undefined,
  idBB: undefined,
  idHB: undefined,
  idHH: undefined,
  idHE: undefined,
  idMV: undefined,
  idNI: undefined,
  idNW: undefined,
  idRP: undefined,
  idSL: undefined,
  idSN: undefined,
  idST: undefined,
  idSH: undefined,
  idTH: undefined,
  bund: 0,
};

export default class Datastock extends Component {
  constructor() {
    super();
    this.state = {
      // state for list
      datastockLines: [],
      activeStatistic: '', // Statistik, die gerade Aktiv ist und als Titel angezeigt wird
      timeClassifyingVariableName: '...', // Label der Zeitvariablen (in Kopfzeile der Tabelle eingeblendet)
      // state for spinner Dialog
      spinnerVisible: false,
      // state for edit-Dialog
      editDialogVisible: false,
      // state for yes-Dialog
      yesDialogState: YesDialogState.invisible,
      // information about the selected button in the table
      selectedStatus: '',
      selectedColumnField: '',
      selectedLine: 0,
    };
    this.messageService = new MessageService();
    this.lockTemplate = this.lockTemplate.bind(this);
    this.hideEditDialog = this.hideEditDialog.bind(this);
    this.hideYesDialog = this.hideYesDialog.bind(this);
    this.showYesDialog = this.showYesDialog.bind(this);
    this.handleUnlock = this.handleUnlock.bind(this);
    this.handleAll = this.handleAll.bind(this);
    this.handleLock = this.handleLock.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.doAsSelected = this.doAsSelected.bind(this);
    this.multiLanguage = new MultiLanguage();
  }

  // onLoad read current data
  componentDidMount = async () => this.loadStatisticList();

  // on click on a Statistic box
  async handleStatistic(name, description) {
    this.setState({
      activeTile: name,
      spinnerVisible: true,
      timeClassifyingVariableName: '...',
      datastockLines: [], // empties all lines before loadRecordStructure!
    });
    try {
      await this.loadRecordStructure(name, 0, false, '');
      this.setState({ activeStatistic: `${name} ${description}` });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('error in handleStatistic', e);
      this.growl.show({ severity: 'info', summary: 'Hinweis', detail: 'Es sind keine Daten vorhanden.' });
      this.setState({
        spinnerVisible: false,
      });
    } finally {
      this.setState({ spinnerVisible: false });
    }
  }

  // on Click to a symbol in table row
  handleClick(selectedTime, selectedColumnField, selectedStatus) {
    const { datastockLines } = this.state;
    for (let selectedLine = 0; selectedLine < datastockLines.length; selectedLine += 1) {
      if (datastockLines[selectedLine].time === selectedTime) {
        if (typeof selectedStatus !== 'undefined') {
          datastockLines[selectedLine][selectedColumnField] = selectedStatus;
          this.setState(
            {
              selectedStatus,
              selectedColumnField,
              selectedLine,
              editDialogVisible: true,
            },
          );
        }
      }
    }
  }

  doLockUnlockAll = async () => {
    // nothing
  }

  doLockUnlock = async (lockedValue, flag) => {
    // find to be unlocked ID in JSON
    let isLocked = lockedValue;
    // prepare message
    const {
      templateNew,
      selectedColumnField,
      datastockLines,
      selectedLine,
      originalData,
    } = this.state;
    const idText = `${selectedColumnField}id2`;
    const index = datastockLines[selectedLine][idText];
    // search for entryID
    const entry = originalData[index];
    entry.mark = flag;
    const send = templateNew.data;
    let rightArea = lockedValue ? 'BEN' : 'GRP';
    if (flag === 'O') rightArea = 'FREE'; // ADBHSSTAT-2078
    send.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0] = entry;
    send.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].ownerInfo.rightArea = rightArea;
    send.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0].mark = '';
    const ret = await this.messageService.postRecordStructureUpdate1(send, ''); // TODO: Name ändern
    if (ret[1] === 'error') {
      this.growl.show({ severity: ret[1], summary: 'Fehler', detail: ret[0] });
      this.setState({
        editDialogVisible: false,
      });
    } else {
      this.growl.show({ severity: 'success', summary: 'Speichern', detail: 'Regionalzeitscheibe wurde aktualisiert.' });
      // set frontend
      if (flag === 'O') isLocked = 'O';
      datastockLines[selectedLine][selectedColumnField] = isLocked;
      // check bund
      const allLands = this.returnAllLands(datastockLines[selectedLine]);
      if (datastockLines[selectedLine].bund === 0 && allLands) {
        datastockLines[selectedLine].bund = 1;
      } else {
        datastockLines[selectedLine].bund = 0;
      }
      // lock data for this time-slice in database
      this.setState({
        datastockLines,
        editDialogVisible: false,
      });
    }
  }

  handleUnlock = async () => {
    this.setState({ spinnerVisible: true });
    const isLocked = false;
    await this.doLockUnlock(isLocked, 'G');
    await this.delay(4000);
    this.setState({ spinnerVisible: false });
  }

  handleStLA = async () => {
    this.setState({ spinnerVisible: true });
    this.growl.show({ severity: 'info', summary: 'Hinweis', detail: 'Noch nicht implementiert.' });
    await this.delay(4000);
    this.setState({ spinnerVisible: false });
  }

  handleStBA = async () => {
    this.setState({ spinnerVisible: true });
    const isLocked = false;
    await this.doLockUnlock(isLocked, 'O');
    await this.delay(4000);
    this.setState({ spinnerVisible: false });
  }

  handleUnlockLand = async () => {
    this.setState({ spinnerVisible: true });
    const isLocked = true;
    await this.doLockUnlock(isLocked, 'M');
    await this.delay(4000);
    this.setState({ spinnerVisible: false });
  }

  handleAll = async () => {
    this.setState({ spinnerVisible: true });
    const isLocked = false;
    await this.doLockUnlock(isLocked, 'O');
    await this.delay(4000);
    this.setState({ spinnerVisible: false });
  }

  handleLock = async () => {
    this.setState({ spinnerVisible: true });
    const isLocked = true;
    await this.doLockUnlock(isLocked, 'B');
    await this.delay(4000);
    this.setState({ spinnerVisible: false });
  }

  handleDelete = async () => {
    this.setState({ spinnerVisible: true });
    const { selectedColumnField, selectedLine, datastockLines } = this.state;
    const qualifyier = `${selectedColumnField}id`;
    const foundId = datastockLines[selectedLine][qualifyier];
    if (foundId) {
      const ret = await this.messageService.getDataStockDelete(foundId);
      await this.delay(4000);
      if (ret[1] === 'error') {
        this.growl.show({ severity: ret[1], summary: 'Fehler', detail: ret[0] });
      } else {
        this.growl.show({ severity: 'success', summary: 'Speichern', detail: 'Regionalzeitscheibe wurde gelöscht.' });
        // delete data for this time-slice
        datastockLines[selectedLine][selectedColumnField] = '';
        this.setState({
          datastockLines,
        });
      }
    }
    this.setState({ spinnerVisible: false });
  }

  returnAllLands(entryLand) {
    return entryLand.BW === 'O' && entryLand.BY === 'O' && entryLand.BE === 'O'
      && entryLand.BB === 'O' && entryLand.HB === 'O' && entryLand.HH === 'O'
      && entryLand.HE === 'O' && entryLand.MV === 'O' && entryLand.NI === 'O'
      && entryLand.NW === 'O' && entryLand.RP === 'O' && entryLand.SL === 'O'
      && entryLand.SN === 'O' && entryLand.ST === 'O' && entryLand.SH === 'O'
      && entryLand.TH === 'O';
  }

  mapNodesNew(entrys) {
    const register = [];
    const result = [];
    for (let i = 0; i < entrys.length; i += 1) {
      const { timesliceExists, name, tmpLock } = entrys[i];
      const { rightArea } = entrys[i].ownerInfo;
      let buttonValue = timesliceExists === false ? undefined : timesliceExists;
      if (timesliceExists) {
        if (tmpLock === null) {
          buttonValue = false;
        } else {
          buttonValue = true;
        }
      }
      if (rightArea === 'BEN' && timesliceExists) buttonValue = true;
      if (rightArea === 'OFFICE' && timesliceExists) buttonValue = true;
      if (rightArea === 'GRP' && timesliceExists) buttonValue = false;
      if (rightArea === 'FREE' && timesliceExists) buttonValue = 'O';
      const aryName = name.split('_');
      let period = aryName[1];
      let sortPeriod = aryName[1];
      const thirdVal = aryName[2];
      if (thirdVal) {
        if (thirdVal.length === 2) {
          const sortVal = thirdVal === 'SS' ? 0 : 1; // 2173
          sortPeriod = `${period}${sortVal}`;
          period = `${thirdVal} ${period}`;
        }
      }
      const { recordStructure } = entrys[i];
      const land = recordStructure.slice(0, 2);
      if (register.indexOf(period) === -1) {
        register.push(period);
        result[period] = JsonHelper.deepCopy(lineTemplate);
        result[period].time = period;
        result[period].sortTime = sortPeriod;
        if (period.length > 4) {
          result[period].timeClassifyingVariableName = "SEMESTER";
        }
      }
      const landId = `${land}id`;
      const landId2 = `${land}id${2}`;
      result[period][land] = buttonValue; // oder 'O' oder 'M'
      result[period][landId] = name; // was id
      result[period][landId2] = i;
    }
    const returnResult = Object.values(result).sort((a, b) => a.sortTime.localeCompare(b.sortTime));
    for (let n = 0; n < returnResult.length; n += 1) {
      const allLands = this.returnAllLands(returnResult[n]);
      if (allLands) returnResult[n].bund = 1;
    }
    return returnResult;
  }

  // eslint-disable-next-line class-methods-use-this
  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  hideEditDialog() {
    this.setState({ editDialogVisible: false });
  }

  hideYesDialog() {
    this.setState({ yesDialogState: YesDialogState.invisible });
  }

  doAsSelected() {
    const { yesDialogState } = this.state;
    if (yesDialogState === YesDialogState.unlock) {
      this.setState({ yesDialogState: YesDialogState.invisible }, () => this.handleUnlock());
    } else if (yesDialogState === YesDialogState.lock) {
      this.setState({ yesDialogState: YesDialogState.invisible }, () => this.handleLock());
    } else if (yesDialogState === YesDialogState.delete) {
      this.setState({ yesDialogState: YesDialogState.invisible }, () => this.handleDelete());
    } else if (yesDialogState === YesDialogState.stla) {
      this.setState({ yesDialogState: YesDialogState.invisible }, () => this.handleStLA());
    } else if (yesDialogState === YesDialogState.stba) {
      this.setState({ yesDialogState: YesDialogState.invisible }, () => this.handleStBA());
    } else if (yesDialogState === YesDialogState.unlockLand) {
      this.setState({ yesDialogState: YesDialogState.invisible }, () => this.handleUnlockLand());
    } else if (yesDialogState === YesDialogState.all) {
      this.setState({ yesDialogState: YesDialogState.invisible }, () => this.handleAll());
    }
  }

  showYesDialog(newYesDialogState) {
    this.setState({
      yesDialogState: newYesDialogState,
      editDialogVisible: false,
    });
  }

  lockTemplate(rowData, column) {
    const { userRights, selectedLine } = this.state;
    const { time } = rowData;
    const { field, header } = column;
    let status = rowData[field];
    const { land, accessLevel } = userRights;
    const isAdmin = userRights.role === 'GROUP_ADMIN';
    const isMinistry = userRights.group.indexOf('Ministerium') > -1;
    let activateAction = false;
    if (isAdmin) {
      const intStatus = parseInt(status, 10);
      if (!intStatus.isNan) {
        if (header === land) {
          if (status < 1) activateAction = false;
        }
      }
    }
    if (accessLevel === 'LAND_GROUP_ADMIN'
      || accessLevel === 'FEDERAL_GROUP_ADMIN'
    ) {
      if (header === land && (status !== '0')) {
        activateAction = true;
      }
    }
    if (status === undefined && land === 'Bund'
      && (accessLevel === 'FEDERAL_GROUP_ADMIN' || accessLevel === 'FEDERAL_SUPER_SUBJECT_ADMIN')) {
      let count = 0;
      for (let key in rowData) {
        if (rowData[key] === 'O') {
          count += 1;
        }
      }
      if (count === 16) {
        status = true;
      } else {
        activateAction = false;
      }
    }
    if (accessLevel === 'FEDERAL_SUPER_SUBJECT_ADMIN') {
      if (status === 'O' || status === true || status === false) {
        activateAction = true;
      }
    }
    if (status === 'O' && accessLevel === 'LAND_GROUP_ADMIN') {
      activateAction = false;
    }
    if (isMinistry) activateAction = false;
    let className = 'p-button-secondary';
    let icon = 'pi-md-crop-free';
    let title = 'fehlende Zeitscheibe';
    // pi-md-lock-outline
    if (status === 'O') {
      className = 'p-button-info';
      icon = 'pi-md-language';
      title = 'freigegeben (allgemein)';
    } else if (status === true) {
      className = 'p-button-warning';
      icon = 'pi-md-lock';
      title = 'gesperrt';
    } else if (status === false) {
      className = 'p-button-success';
      icon = 'pi-md-lock-open';
      title = 'freigegeben';
    } else if (status === 0) {
      icon = 'pi-md-lock-outline';
      title = 'fehlende Zeitscheibe oder Freigabe';
    }
    let onclickAction;
    if (activateAction) onclickAction = () => this.handleClick(time, field, status);
    const style = activateAction ? { cursor: 'pointer' } : { cursor: 'default' };
    return (
      <Button
        id={rowData.time.replace(/\s/g, '') + field}
        className={className}
        icon={icon}
        onClick={onclickAction}
        title={title}
        style={style}
      />
    );
  }

  async loadStatisticList(returnMessage) {
    const userRights = returnUserRights();
    const statisticsList = await this.messageService.postStatisticDirectory(returnMessage);
    this.setState({
      userRights,
      statisticsList,
    });
  }

  // loads data of statistic on click on a statistic
  async loadRecordStructure(statistic) {
    const elementsDataNew1 = await this.messageService.postDataStockProperties1(statistic, 'directory', 'filedescriptor');
    const entrysNew = elementsDataNew1.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys;
    let templateNew = elementsDataNew1;
    const datastockLines = this.mapNodesNew(entrysNew);
    const elementsDataNew = await this.messageService.postDataStockProperties1(statistic, 'properties', 'cubefromfile');
    if (elementsDataNew1[1] && elementsDataNew1[1] === 'error') {
      this.growl.show({ severity: elementsDataNew[1], summary: 'Hinweis', detail: elementsDataNew[0] });
    } else {
      this.growl.show({ severity: 'success', summary: 'Hinweis', detail: 'Daten wurde geladen' });
      let timeClassifyingVariableName = 'SEMESTER';
      if (datastockLines[0].time.length === 4) timeClassifyingVariableName = 'JAHR';
      templateNew = elementsDataNew1;
      templateNew.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys = [];
      this.setState({
        templateNew,
        datastockLines,
        timeClassifyingVariableName,
        // origLoadedData: data,
        originalData: entrysNew,
      });
    }
  }

  editDialogFooter(selectedColumnField) {
    const { selectedStatus, userRights } = this.state;
    const accessLevel = userRights?.accessLevel;
    const deleteForUser = selectedColumnField !== 'DE';
    // Buttons
    const freigeben = (
      <Button
        label="Freigeben"
        id="yes"
        type="button"
        icon="pi-md-check"
        onClick={() => this.showYesDialog(YesDialogState.unlock)}
        className="p-button-success"
        disabled={selectedStatus === true ? '' : true}
      />
    );
    const freigebenBund = (
      <Button
        label="Für StBA freigeben"
        id="unlock"
        type="button"
        icon="pi-md-lock-open"
        onClick={() => this.showYesDialog(YesDialogState.stba)}
        className="p-button-success"
        disabled={selectedStatus === false || selectedStatus === 'O' ? true : false}
      />
    );
    const freigebenOeffentlich = (
      <Button
        label="Allgemein freigeben"
        id="unlock"
        type="button"
        icon="pi-md-language"
        onClick={() => this.showYesDialog(YesDialogState.all)}
        className="p-button-info"
        disabled={selectedStatus === false ? false : true}
      />
    );
    const sperren = (
      <Button
        label="Sperren"
        id="lock"
        type="button"
        icon="pi-md-lock"
        onClick={() => this.showYesDialog(YesDialogState.lock)}
        className="p-button-warning"
        disabled={selectedStatus === false || selectedStatus === 'O' ? false : true}
      />
    );
    const loeschen = (
      <Button
        label="Löschen"
        id="delete"
        type="button"
        icon="pi-md-delete-forever"
        onClick={() => this.showYesDialog(YesDialogState.delete)}
        className="p-button-danger"
        disabled={selectedStatus === true && deleteForUser ? false : true}
      />
    );
    const abbrechen = (
      <Button
        label="Abbrechen"
        id="cancel"
        type="button"
        icon="pi pi-times"
        onClick={this.hideEditDialog}
        className="p-button-primary"
      />
    );
    const landButtons = (
      <div>
        {freigeben}
        {freigebenOeffentlich}
        {abbrechen}
      </div>
    );
    const bundButtons = (
      <div>
        {freigebenBund}
        {freigebenOeffentlich}
        {sperren}
        {abbrechen}
      </div>
    );
    const superLandButtons = (
      <div>
        {freigeben}
        {freigebenOeffentlich}
        {sperren}
        {loeschen}
        {abbrechen}
      </div>
    );
    let ret = bundButtons;
    if (accessLevel === 'LAND_GROUP_ADMIN') {
      ret = landButtons;
    }
    if (accessLevel === 'FEDERAL_SUPER_SUBJECT_ADMIN' && selectedColumnField !== 'DE') {
      ret = superLandButtons;
    }
    return ret;
  }

  yesDialogFooter() {
    return (
      <div>
        <Button
          label="Ja"
          id="unlock"
          type="button"
          icon="pi pi-check"
          onClick={() => { this.doAsSelected(); }}
          className="p-button-success"
        />
        <Button
          label="Nein"
          id="lock"
          type="button"
          icon="pi pi-times"
          onClick={this.hideYesDialog}
          className="p-button-danger"
        />
      </div>
    );
  }

  renderMetaDataContent(statisticsList) {
    const { activeTile } = this.state;
    let ret = (<div />);
    if (statisticsList) {
      if (statisticsList.length === 0) {
        ret = (
          <div>
            <Panel style={{ backgroundColor: '#F44336', color: 'white' }}>
              Fehler: Die Statistiken konnten nicht geladen werden.
            </Panel>
          </div>
        );
      } else if (statisticsList.length === 2 && statisticsList[1] === 'info') {
        ret = (
          <div>
            <Panel style={{ backgroundColor: 'grey', color: 'white' }}>
              Es sind keine Statistiken verfügbar.
            </Panel>
          </div>
        );
      } else {
        ret = (
          <div>
            <Card>
              <div className="p-grid dashboard">
                {statisticsList.map((s, i) => {
                  const key = `statistic-number-${i}`;
                  return (
                    <div
                      role="button"
                      id={s.name}
                      key={key}
                      className="p-col-12 p-md-2"
                      onClick={() => this.handleStatistic(s.name, this.multiLanguage.returnInLanguage(s, 'de'))}
                      onKeyPress={() => { }}
                      tabIndex={i}
                    >
                      <div className={s.name === activeTile ? 'overview-box overview-box-3' : 'overview-box overview-box-4'}>
                        <div className="overview-box-header" />
                        <div className="overview-box-content">
                          <div className="overview-box-icon"><i className="material-icons">assessment</i></div>
                          <div className="overview-box-title">{s.name}</div>
                          <div className="overview-box-count">{this.multiLanguage.returnInLanguage(s, 'de')}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Card>
          </div>
        );
      }
    }
    return ret;
  }

  renderYesDialog() {
    const { yesDialogState } = this.state;
    return (
      <Dialog
        header="Datenbestand: Bestätigung"
        visible={!(yesDialogState === YesDialogState.invisible)}
        style={{ width: '30vw' }}
        modal
        footer={this.yesDialogFooter()}
        onHide={this.hideYesDialog}
      >
        <p>
          Sind Sie sich sicher, dass Sie die ausgewählten Wertedaten
          {' '}
          {YesDialogState[yesDialogState]}
          {' '}
          möchten?
        </p>
      </Dialog>
    );
  }

  renderEditDialog(selectedTime) {
    const {
      editDialogVisible,
      selectedColumnField,
      // selectedStatus,
      userRights,
    } = this.state;
    const landText = LandNames[selectedColumnField];
    const accessLevel = userRights?.accessLevel;
    let land = 'für den Bund';
    let group = '';
    let regionalIdentification = 'freigeben, allgemein freigeben oder sperren?';
    if (accessLevel === 'LAND_GROUP_ADMIN') {
      land = `des Landes ${landText}`;
      group = 'gruppenspezifisch ';
      regionalIdentification = `${group}freigeben oder allgemein freigeben?`;
    }
    if (accessLevel === 'FEDERAL_SUPER_SUBJECT_ADMIN' && selectedColumnField !== 'DE') {
      land = `des Landes ${landText}`;
      group = 'gruppenspezifisch ';
      regionalIdentification = `${group}freigeben, allgemein freigeben, sperren oder löschen?`;
    }
    const action = 'Bitte wählen Sie die entsprechende Aktion.';
    return (
      <Dialog
        header="Datenbestand"
        visible={editDialogVisible}
        style={{ width: '48vw' }}
        modal
        footer={this.editDialogFooter(selectedColumnField)}
        onHide={this.hideEditDialog}
      >
        <p>
          Möchten Sie die Wertedaten
          {' '}
          {land}
          {' '}
          zum Berichtszeitraum
          {' '}
          {selectedTime}
          {' '}
          {regionalIdentification}
          <br />
          {action}
        </p>
      </Dialog>
    );
  }

  renderSpinner() {
    const { spinnerVisible } = this.state;
    return (
      <Dialog
        header="Aktualisiere Daten..."
        closable={false}
        closeOnEscape={false}
        visible={spinnerVisible}
        modal
        onHide={() => this.setState({ spinnerVisible: false })}
      >
        <center><ProgressSpinner /></center>
      </Dialog>
    );
  }

  render() {
    const {
      datastockLines, timeClassifyingVariableName, statisticsList, selectedLine, activeStatistic,
    } = this.state;
    let selectedTime = '';
    if (typeof (datastockLines[0]) !== 'undefined') selectedTime = datastockLines[selectedLine]?.time;
    return (
      <div>
        <div>
          <Growl style={{ position: 'absolute', left: '78.5%', top: '345px' }} ref={(el) => { this.growl = el; }} />
        </div>
        <div className="p-col">
          {this.renderMetaDataContent(statisticsList)}
        </div>
        <div>
          {this.renderSpinner()}
          {this.renderYesDialog()}
          {this.renderEditDialog(selectedTime)}
          {datastockLines.length > 0
            ? (
              <h2>
                <b>
                  Datenbestand:&ensp;
                  {activeStatistic}
                </b>
              </h2>
            ) : ''}
          <DataTable value={datastockLines}>
            <Column field="time" header={timeClassifyingVariableName} style={{ textAlign: 'center', width: '6em' }} />
            <Column field="BW" header="BW" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="BY" header="BY" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="BE" header="BE" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="BB" header="BB" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="HB" header="HB" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="HH" header="HH" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="HE" header="HE" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="MV" header="MV" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="NI" header="NI" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="NW" header="NW" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="RP" header="RP" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="SL" header="SL" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="SN" header="SN" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="ST" header="ST" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="SH" header="SH" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="TH" header="TH" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
            <Column field="DE" header="Bund" body={this.lockTemplate} style={{ textAlign: 'center', width: '3em' }} />
          </DataTable>
        </div>
        <p />
        <div>
          <Card>
            <Button
              className="p-button-warning"
              icon="pi-md-lock"
              style={{ cursor: 'default' }}
            />
            nicht freigegeben&nbsp;
            <Button
              className="p-button-success"
              icon="pi-md-lock-open"
              style={{ cursor: 'default' }}
            />
            Freigabe für StLA oder StBA&nbsp;
            <Button
              className="p-button-info"
              icon="pi-md-language"
              style={{ cursor: 'default' }}
            />
            Freigabe (allgemein);
          </Card>
        </div>
      </div>
    );
  }
}
